import { userFavSceneActions } from '../../actions/user/userFavSceneActions.js';

const INITIAL_STATE = {
    isFetching: false,
    error: '',
    scenes:[],
    count: 0,
      sites: {
        "available": [
        {
        "siteId": 25,
        "shortName": "ap",
        "name": "Ass Parade"
        }],
        "selected":  {
          "siteId": 25,
          "shortName": "ap",
          "name": "Ass Parade"
          }
      },
      models: {
        available: [],
        selected: []
      },
      tags: {
        available: [],
        selected: []
      },
      movies: {
        available: [],
        selected: []
      }
}

const userFavSceneReducers = (state = INITIAL_STATE, action) =>{
    switch(action.type){
        case userFavSceneActions.SCENE_FAV_REQUEST:
            return {
                ...state,
                isFetching: true
            };
        case userFavSceneActions.SCENE_FAV_SUCCESS:
            return{
                ...state,
                isFetching: false,
                scenes: action.scenes,
                // sites: action.sites,
                // models: action.models,
                // tags: action.tags,
                count: action.count
            }
        case userFavSceneActions.SCENE_FAV_FAILURE:
            return{
                ...state,
                isFetching: false,
                error: action.error
            }
        default:
            return state;
    }
};

export default userFavSceneReducers;
